import React from "react";
import IconButton from "../../../common/icon-button/icon-button";
import TextOverflowTooltip from "../../../common/TextOverflowTooltip";
import WidgetOptions from "../widget-options/widget-options";

const WidgetHeader = ({
  isEditAllowed,
  title,
  height,
  width,
  children,
  showWidgetInfo,
  openConfiguration,
  onRemove,
  onClone,
}) => {
  return (
    <div className="glu-content__header">
      {isEditAllowed && (
        <div className="glu-flex-shrink">
          <IconButton className="glu-icon__draggable cursor-move" icon="drag" />
        </div>
      )}
      <TextOverflowTooltip
        title={title}
        height={height}
        width={width}
        renderChildren={(ref) => (
          <div className="glu-flex-grow">
            <div className="glu-page__title glu-widget-title" ref={ref}>
              {title}
            </div>
          </div>
        )}
      />
      <div className="glu-flex-row">
        {children}

        {isEditAllowed && (
          <WidgetOptions
            showWidgetInfo={showWidgetInfo}
            openConfiguration={openConfiguration}
            onRemove={onRemove}
            onClone={onClone}
          />
        )}
      </div>
    </div>
  );
};

export default WidgetHeader;
